import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1947e855"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FeedbackForm" }
const _hoisted_2 = { class: "Heading1" }
const _hoisted_3 = { class: "Heading2" }
const _hoisted_4 = ["placeholder", "value"]
const _hoisted_5 = { class: "Heading2" }
const _hoisted_6 = ["onClick", "onMouseover"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" - ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.mixWB('GIVE_US_YOUR_FEEDBACK')), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.mixWB('HELP_US_TO_DO_BETTER_TEXT')), 1),
    _createElementVNode("textarea", {
      placeholder: _ctx.mixWB('FEEDBACK_MESSAGE_PLACEHOLDER_TEXT'),
      value: _ctx.description,
      required: "",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateDescription && _ctx.updateDescription(...args)))
    }, null, 40, _hoisted_4),
    _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.mixWB('RATING_LABEL')) + " (" + _toDisplayString(_ctx.mixWB('OPTIONAL_2')) + ")", 1),
    _createElementVNode("ul", {
      class: "Rating",
      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setHover(0)))
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
        return _createElementVNode("li", {
          key: n,
          class: _normalizeClass(["Star", {
            IsSelected: !_ctx.hovering && n <= _ctx.rating,
            IsHovering: n <= _ctx.hovering
          }]),
          onClick: ($event: any) => (_ctx.updateRating(n)),
          onMouseover: ($event: any) => (_ctx.setHover(n))
        }, [
          _createVNode(_component_InlineSVG, {
            src: require('@/assets/svg/star.svg')
          }, null, 8, ["src"])
        ], 42, _hoisted_6)
      }), 64))
    ], 32),
    _createElementVNode("div", {
      class: _normalizeClass(["StatusLine", { IsHidden: !_ctx.rating}])
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.rating === 1 ? _ctx.mixWB('1_STAR_SELECTED') : _ctx.mixWB('X_STARS_SELECTED', [_ctx.rating.toString()])), 1),
      _hoisted_7,
      _createElementVNode("button", {
        class: "ResetButton",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateRating(0)))
      }, _toDisplayString(_ctx.mixWB('RESET')), 1)
    ], 2)
  ]))
}